<div class="wrapper sidebar-l">
  <div class="mobile-sidebar-toggle">
    <button class="mobile-menu-button" type="button" (click)="toggleMobileMenu()" [attr.aria-expanded]="isMobileMenuOpen">
      <span class="mobile-menu-button__icon">&#9776;</span>
    </button>
  </div>

  <div class="mobile-sidebar-backdrop" *ngIf="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

  <div class="sidebar-panel" [class.sidebar-open]="isMobileMenuOpen">
    <div class="list-wrapper margin-b ">
    <div class="header border-r color" style="background-color: #f24e2b">
      <div>Community</div>
    </div>
    <div class="list border-r">
      <div class="items" *ngFor="let props of sidebarFirst">
        <a [routerLink]="[props.route]" routerLinkActive="active-list" [routerLinkActiveOptions]="{exact: true}"
          [ngClass]="{ 'notif-pill': props.name === 'Notifications' && unreadCount > 0 }" (click)="closeMobileMenu()">
          {{props.name}}
          <span *ngIf="props.name === 'Notifications' && unreadCount > 0" class="notif-badge">{{ unreadCount }}</span>
        </a>
      </div>
    </div>
  </div>

  <div class="list-wrapper margin-b">
    <div class="header border-r color" style="background-color: #2eb8d5">
      <div> Engagement</div>
    </div>

    <div class="list border-r">
      <div class="items">
        <a routerLink="/cross-chat" routerLinkActive="active-list-second"
          [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">Cross Chat</a>
      </div>


      <div class="items">
        <a routerLink="/social-feed" routerLinkActive="active-list-second"
          [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">Ravel Cafe</a>
      </div>
      <div class="items"> <a routerLink="/post-cards" routerLinkActive="active-list-second"
          [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
          Postcards </a></div>

      <!-- <div class="items"> <a routerLink="/alerts" routerLinkActive="active-list-second"
          [routerLinkActiveOptions]="{exact: true}">
          Alerts </a></div> -->
      <div class="items"> <a routerLink="/alerts" routerLinkActive="active-list-second"
          [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
          Alerts </a></div>



      <div class="items"> <a routerLink="/event-manager" routerLinkActive="active-list-second"
          [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
          Events </a></div>
      <div class="items"> <a routerLink="/housing-hub" routerLinkActive="active-list-second"
          [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
          Housing Hub </a></div>

      <div class="items"> <a routerLink="/jobs" routerLinkActive="active-list-second"
          [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
          Create Job</a></div>

      <!-- Association Manager visible only for Headquarters -->
      <div class="items" *ngIf="isHeadQuarters">
        <a routerLink="/association-manager" routerLinkActive="active-list-second"
          [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">Association Manager</a>
      </div>






    </div>


    <div class="list-wrapper margin-b">
      <div class="header border-r color" style="background-color: #FFC400">
        <div> Media</div>
      </div>

      <div class="list border-r">
        <div class="items"> <a routerLink="/photo-gallery" routerLinkActive="active-list-second"
            [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
            Photo Gallery </a></div>


        <div class="items"> <a routerLink="/video-manager" routerLinkActive="active-list-second"
            [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
            Video Manager </a></div>
        <div class="items"> <a routerLink="/bulletins" routerLinkActive="active-list-second"
            [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
            Bulletin </a>
        </div>




      </div>







      <!-- <div class="list-wrapper margin-b">
    <div class="header border-r color" style="background-color: #2eb8d5">
      <div>Engagement</div>
    </div>
    <div class="list border-r">
      <div class="items" *ngFor="let props of sidebarSecond">
        <a [routerLink]="[props.route]" routerLinkActive="active-list-second" [routerLinkActiveOptions]="{exact: true}">
          {{props.name}}
        </a> </div>

    </div>
  </div> -->

      <div class="list-wrapper margin-b">
        <div class="header border-r color" style="background-color: #666666">
          <div>Profile Management</div>
        </div>
        <div class="list border-r">
          <div class="items" *ngFor="let props of sidebarThird">
            <a [routerLink]="[props.route]" routerLinkActive="active-list-third"
              [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
              {{props.name}}
            </a>
          </div>


          <div class="items">
            <a class="cursor" id="logout" [ngClass]="{'active':activeTab == 'logout'}" (click)="logout()">Logout</a>


          </div>

          <!-- <div class="items">
        <a class="cursor" id="logout" [ngClass]="{'active':activeTab == 'logout'}" (click)="subitem('item')">Events</a>

        <div class="subitem" *ngIf="section == 'item'">
          <div class="item">
          <a class="cursor" id="logout" [ngClass]="{'active':activeTab == 'logout'}">dsfdsfds</a>
        </div>
      </div>
    </div> -->
        </div>
    </div>
  </div>
</div>
